import { Container, Typography, Accordion, AccordionSummary, AccordionDetails, Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqs = [
    {
        q: 'Does Capitol Gains make trades for me?',
        a: 'No. Capitol Gains is not a trading platform. We provide transparency tools and insights for monitoring the stock trades of U.S. Congress members.',
    },
    {
        q: 'Is Capitol Gains a financial advisor?',
        a: 'No. We are not a licensed financial advisor. We provide information and analysis based on public data but do not offer personalized financial advice.',
    },
    {
        q: 'Where do you get Congress stock trades from?',
        a: 'We source disclosures directly from the Senate Public Financial Disclosure Database and the House of Representatives Financial Disclosure Reports. Data is refreshed daily.',
    },
    {
        q: 'How often is the data updated?',
        a: 'Daily. We pull the latest filings from Congress members every day.',
    },
    {
        q: 'Do I need a subscription?',
        a: 'No. All Congress stock trades, issuer pages, and trading analytics are free and open — no signup needed. Pro unlocks our scored stock picks, options activity, and real-time email alerts on members you track.',
    },
    {
        q: 'How can I use this information?',
        a: 'Use it to stay informed about the financial activities of elected officials and to inform your own research. Investment decisions are yours to make independently.',
    },
    {
        q: 'Is my personal information safe?',
        a: 'Yes. We use industry-standard encryption and security measures. See our Privacy Policy for full details.',
    },
    {
        q: 'Can I cancel my subscription at any time?',
        a: 'Yes. You can cancel at any time. Access to premium features continues until the end of your current billing cycle. See our Refund Policy for more.',
    },
    {
        q: 'Do you provide investment recommendations?',
        a: 'No. We provide transparency into Congress members\' stock trades, not personalized investment advice.',
    },
];

const FAQ = () => (
    <Container maxWidth="md" sx={{ pt: 6, pb: 8 }}>
        <Typography variant="h1" sx={{ color: 'text.primary', mb: 0.5 }}>
            Frequently asked questions
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
            Quick answers to common questions about Capitol Gains.
        </Typography>

        <Box sx={{
            borderRadius: 1.5,
            border: t => `1px solid ${t.palette.custom.border.subtle}`,
            overflow: 'hidden',
            bgcolor: 'custom.surface.raised',
        }}>
            {faqs.map((faq, i) => (
                <Accordion
                    key={i}
                    disableGutters
                    elevation={0}
                    square
                    sx={{
                        bgcolor: 'transparent',
                        borderBottom: t => i < faqs.length - 1 ? `1px solid ${t.palette.custom.border.subtle}` : 'none',
                        '&:before': { display: 'none' },
                    }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: 'text.muted' }} />}
                        sx={{ px: 3, py: 0.5 }}
                    >
                        <Typography variant="body1" sx={{ color: 'text.primary', fontWeight: 500 }}>
                            {faq.q}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ px: 3, pb: 2.5, pt: 0 }}>
                        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                            {faq.a}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>

        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 4, textAlign: 'center' }}>
            Still have questions?{' '}
            <Link component={RouterLink} to="/contact" sx={{ color: 'primary.light' }}>
                Get in touch
            </Link>
        </Typography>
    </Container>
);

export default FAQ;
